export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Magazin online."},{"name":"format-detection","content":"telephone=no"},{"property":"og:locale","content":"ro_RO"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Magazin"},{"name":"twitter:card","content":"summary_large_image"}],"link":[{"key":"site-favicon","rel":"icon","type":"image/webp","href":"/brand-placeholder.webp"},{"key":"site-apple-touch-icon","rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"preconnect","href":"https://api.novartshop.ro","crossorigin":"anonymous"}],"style":[],"script":[{"key":"ios-webkit-bridge-stub","innerHTML":"(function(){try{var n=navigator,ua=n.userAgent||\"\",ios=/iP(hone|ad|od)/.test(ua)||(n.platform===\"MacIntel\"&&n.maxTouchPoints>1);if(!ios)return;var w=window;if(!w.webkit)w.webkit={};if(w.webkit.messageHandlers)return;var s={};w.webkit.messageHandlers=new Proxy(s,{get:function(o,p){if(typeof p===\"symbol\"||p===\"then\")return;var k=String(p);if(k in o)return o[k];var t={postMessage:function(){}};o[k]=t;return t}})}catch(e){}})();","type":"text/javascript","tagPosition":"head","tagPriority":"critical"},{"key":"bfcache-fix","innerHTML":"(function(){var o=history.replaceState.bind(history);window.addEventListener(\"pagehide\",function(e){if(!e.persisted)return;history.replaceState=function(){};queueMicrotask(function(){history.replaceState=o})},!0);function r(e){return\"function\"==typeof e&&Function.prototype.toString.call(e).indexOf(\"replaceState\")>-1&&Function.prototype.toString.call(e).indexOf(\"visibilityState\")>-1}function t(e){return function(n){if(n.persisted)return;return e.call(window,n)}}var n=window.addEventListener.bind(window),i=document.addEventListener.bind(document);window.addEventListener=function(e,i,a){return\"pagehide\"===e&&\"function\"==typeof i?n(e,t(i),a):n(e,i,a)},document.addEventListener=function(e,t,n){return\"visibilitychange\"===e&&r(t)?void 0:i(e,t,n)}})();","type":"text/javascript","tagPosition":"head","tagPriority":"critical"}],"noscript":[],"htmlAttrs":{"lang":"ro"},"charset":"utf-8","viewport":"width=device-width, initial-scale=1","title":"Magazin"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt","class":"isolate"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true